import { StatusEnum } from '../types';

const STATUS_COLORS = {
  [StatusEnum.ACTIVE]: 'bg-green-700',
  [StatusEnum.PENDING]: 'bg-blue-700',
  [StatusEnum.CLOSED]: 'bg-amber-700',
};

export default STATUS_COLORS;
